"use client";

import BlokWrap from "@/components/bloks/BlokWrap";
import { ChevronRight } from "@/components/icons/Chevron";
import { Link } from "@/i18n/Link";
import { trackContentClick } from "@/lib/analytics/trackContentClick";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokChecklist } from "@/storyblok";
import type { BlokProps, MultilinkStoryblok } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import type { StoryblokMultilink } from "storyblok";
import { DownloadLink } from "../DownloadButtonBlok";
import styles from "./Checklist.module.css";

export const ChecklistBlok = ({ blok }: BlokProps<BlokChecklist>) => {
	return (
		<BlokWrap editable={blok} as="div" className={styles.root}>
			{blok.title && (
				<h2 className={clsx(styles.title, blok.small && styles.small)}>{blok.title}</h2>
			)}
			<nav className={styles.nav}>
				<ul className={styles.list}>
					{blok.items?.map((item) => {
						if (item.component === "downloadButton") {
							return (
								<li key={item._uid}>
									<DownloadLink
										blok={item}
										className={styles.item}
										onClick={() =>
											trackContentClick({
												contentType: item.component,
												itemId: item._uid,
												label: item.text,
											})
										}
									>
										<span className={styles.icon}>
											<ChevronRight />
										</span>
										{item.text}
									</DownloadLink>
								</li>
							);
						}

						const link = sbLink(item.link as StoryblokMultilink);
						if (!link) return null;
						return (
							<li key={item._uid}>
								<Link
									className={styles.item}
									href={link.href}
									onClick={() =>
										trackContentClick({
											contentType: item.component,
											itemId: item._uid,
											href: link.href,
											label: item.text,
										})
									}
								>
									<span className={styles.icon}>
										<ChevronRight />
									</span>
									{item.text}
								</Link>
							</li>
						);
					})}
				</ul>
			</nav>
		</BlokWrap>
	);
};

export const ChecklistIcon = () => {
	return (
		<span className={styles.icon}>
			<ChevronRight />
		</span>
	);
};
